<template>
  <div>
    <el-card style="height:450px;">
      <div slot="header">
        <span>待办工作统计</span>
      </div>
      <div class="space"></div>
      <el-row>
        <el-col :span="8"
                v-for="state in stateList"
                :key="state.Name">
          <div class="wrap">
            <img :src="imgList[state.Name]"
                 alt
                 class="img">
            <span class="number">{{state.Value}}</span>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { GetTaskStatsByTaskState } from "@/api/modules/basicData/task.js";
export default {
  name: "TaskStatTodo",
  data() {
    return {
      stateList: [],
      imgList: {
        执行中: require("@/assets/img/执行中.png"),
        待接收: require("@/assets/img/待接收.png"),
        待审批: require("@/assets/img/待审核.png")
      }
    };
  },
  methods: {
    refresh(request) {
      GetTaskStatsByTaskState({
        TimeType: 0,
        TimeRange: 0,
        UserId: request.UserId,
        TaskIds: request.TaskIds || "",
        Paras: request.Paras || {},
        ServerCenterId: request.ServerCenterId || ""
      })
        .then(res => {
          this.stateList = res;
        })
        .catch(error => {
          console.log(error);
          // this.$message.error("获取统计数据失败");
        });
    }
  }
};
</script>

<style lang="less" scoped>
.number {
  font-size: 34px;
  font-weight: bold;
  position: relative;
  top: -69px;
  left: 23px;
  color: #fff;
}
.img {
  width: 100%;
}
.wrap {
  margin: 12px;
  padding-bottom: 12px;
}
.space {
  width: 100%;
  height: 100px;
}
</style>
